import {
  ApplicationInsights,
  DistributedTracingModes,
} from "@microsoft/applicationinsights-web";

const setupInstrumentation = () => {
  const app = document.getElementById("app");
  const raw = app?.dataset.instrument;

  if (!raw) {
    return;
  }

  const { connectionString, userId } = JSON.parse(raw);

  if (connectionString) {
    const appInsights = new ApplicationInsights({
      config: {
        connectionString,
        distributedTracingMode: DistributedTracingModes.W3C,
        enableCorsCorrelation: false,
      },
    });
    appInsights.loadAppInsights();
    if (userId) appInsights.setAuthenticatedUserContext(String(userId));
    appInsights.trackPageView();
  }
};

setupInstrumentation();
